import {ComponentClassName} from "@dp-instant/ui";
import cn from "classnames";
import {useInjection} from "@dp-instant/ui";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";
import "./UserStatusInfo.less";
import {Localize} from "@dp-instant/i18n";
import {SIOConstants} from "@game/constants";

/**
 *
 * @description  Component for displaying user auth state. It will be drawn only on yandex platform
 */
export const UserStatusInfo = ({
    className,
    authorized,
    onLogin
}: ComponentClassName & {authorized: boolean; onLogin?: () => void}) => {
    const social: ISocial & {userAuthorized?: boolean} = useInjection(TypesSocial.model);

    return __SOCIAL__ === "ya" ? (
        <div className={cn("user-status-info", className, {authorized: authorized})}>
            {!authorized ? (
                <p className={"user-status-info-alert"}>
                    {Localize.get(
                        "game_login_text",
                        "Log in to compete with others and guaranteed to save progress."
                    )}
                    <button
                        className={cn("login-btn", "btn")}
                        type="button"
                        onClick={() => {
                            onLogin && onLogin();
                        }}
                    >
                        {Localize.get("game_login_btn", "Login")}
                    </button>
                </p>
            ) : null}
        </div>
    ) : __SOCIAL__ === "yt" || __SOCIAL__ === "ls" ? (
        <div className={cn("user-status-info")} style={"visibility: visible; display: block;"}>
            {SIOConstants.HARD_VERSION}
        </div>
    ) : null;
};
